import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LiffService } from 'src/app/shared/liff.service';
import { LiffGuard } from './shared/liff.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '',
    canActivate: [LiffGuard],
    children: [
      {
        path: 'med-sales',
        loadChildren: () => import('./med-sales/med-sales.module').then((m) => m.SalesModule),
      },
      {
        path: 'hcp',
        loadChildren: () => import('./hcp/hcp.module').then((m) => m.HcpModule),
      },
      {
        path: 'sso',
        loadChildren: () => import('./sso/sso.module').then((m) => m.SsoModule),
      },
      {
        path: 'article',
        loadChildren: () => import('./article/article.module').then((m) => m.ArticleModule),
      },
      {
        path: 'survey',
        loadChildren: () => import('./survey/survey.module').then((m) => m.SurveyModule),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
  providers: [LiffService],
})
export class AppRoutingModule {}
